<div class="content-item">
  <ng-content></ng-content>
</div>
